/**
 * Luxire Fit Bible — Interactive Measurement Guide
 * Dependencies: fit-bible-data.js (fbSizeData global)
 */
(function() {
  'use strict';
  var fb = document.getElementById('fit-bible');
  if (!fb) return;

  /* ── Garment pill selection ── */
  var garmentPills = fb.querySelectorAll('[data-fb-garment]');
  var garmentSections = fb.querySelectorAll('[data-fb-section]');

  function activateGarment(target) {
    for (var i = 0; i < garmentPills.length; i++) {
      garmentPills[i].classList.toggle('is-active', garmentPills[i].getAttribute('data-fb-garment') === target);
    }
    for (var s = 0; s < garmentSections.length; s++) {
      garmentSections[s].classList.toggle('is-active', garmentSections[s].getAttribute('data-fb-section') === target);
    }
  }

  for (var i = 0; i < garmentPills.length; i++) {
    garmentPills[i].addEventListener('click', function() {
      activateGarment(this.getAttribute('data-fb-garment'));
      var measure = document.getElementById('fb-measure');
      if (measure) measure.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ── Hash-based deep linking ── */
  function checkHash() {
    var hash = window.location.hash.replace('#', '');
    if (hash && fb.querySelector('[data-fb-garment="' + hash + '"]')) {
      activateGarment(hash);
    }
  }
  checkHash();
  window.addEventListener('hashchange', checkHash);

  /* ── Method card selection (per garment section) ── */
  var methodCards = fb.querySelectorAll('[data-fb-method]');
  for (var i = 0; i < methodCards.length; i++) {
    methodCards[i].addEventListener('click', function() {
      var section = this.closest('[data-fb-section]');
      var target = this.getAttribute('data-fb-method');

      var siblings = section.querySelectorAll('[data-fb-method]');
      for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-active');
      this.classList.add('is-active');

      var panels = section.querySelectorAll('[data-fb-panel]');
      for (var p = 0; p < panels.length; p++) {
        panels[p].classList.toggle('is-active', panels[p].getAttribute('data-fb-panel') === target);
      }
    });
  }

  /* ── Initialize: show first method panel in each section ── */
  for (var s = 0; s < garmentSections.length; s++) {
    var firstPanel = garmentSections[s].querySelector('[data-fb-panel]');
    if (firstPanel) firstPanel.classList.add('is-active');
  }

  /* ── Size chart rendering ── */
  if (typeof window.fbSizeData === 'undefined') return;
  var data = window.fbSizeData;

  function renderPantsTable(tableId, pantType) {
    var table = document.getElementById(tableId);
    if (!table || !data.pants[pantType]) return;
    var tbody = table.querySelector('tbody');
    var rows = data.pants[pantType];
    var html = '';
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      html += '<tr><td>' + r.size + '</td><td>' + r.waist + '</td><td>' + r.hip + '</td><td>' + r.fr + '</td><td>' + r.br + '</td><td>' + r.thigh + '</td><td>' + r.knee + '</td><td>' + r.bottom + '</td></tr>';
    }
    tbody.innerHTML = html;
  }

  function renderShirtsTable(tableId, fit, sizing) {
    var table = document.getElementById(tableId);
    if (!table) return;
    var thead = table.querySelector('thead tr');
    var tbody = table.querySelector('tbody');
    var key = fit + '_' + sizing;
    var rows = data.shirts[key];
    if (!rows) return;
    var html = '';
    if (sizing === 'collar') {
      thead.innerHTML = '<th>Collar</th><th>Chest</th><th>Waist</th><th>Bottom</th><th>Yoke</th><th>Biceps</th><th>Cuff</th><th>Length</th>';
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        html += '<tr><td>' + r.collar + '</td><td>' + r.chest + '</td><td>' + r.waist + '</td><td>' + r.bottom + '</td><td>' + r.yoke + '</td><td>' + r.biceps + '</td><td>' + r.cuff + '</td><td>' + r.length + '</td></tr>';
      }
    } else {
      thead.innerHTML = '<th>Size</th><th>Neck</th><th>Chest</th><th>Waist</th><th>Bottom</th><th>Yoke</th><th>Armhole</th><th>Biceps</th><th>Cuff</th><th>Length</th>';
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        html += '<tr><td>' + r.size + '</td><td>' + r.neck + '</td><td>' + r.chest + '</td><td>' + r.waist + '</td><td>' + r.bottom + '</td><td>' + r.yoke + '</td><td>' + r.armhole + '</td><td>' + r.biceps + '</td><td>' + r.cuff + '</td><td>' + r.length + '</td></tr>';
      }
    }
    tbody.innerHTML = html;
  }

  function renderJacketsTable(tableId, fit, length) {
    var table = document.getElementById(tableId);
    if (!table) return;
    var tbody = table.querySelector('tbody');
    var key = fit + '_' + length;
    var rows = data.jackets[key];
    if (!rows) return;
    var html = '';
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      html += '<tr><td>' + r.size + '</td><td>' + r.shoulder + '</td><td>' + r.chest + '</td><td>' + r.midsection + '</td><td>' + r.hip + '</td><td>' + r.back_length + '</td><td>' + r.sleeve + '</td><td>' + r.bicep + '</td><td>' + r.opening + '</td></tr>';
    }
    tbody.innerHTML = html;
  }

  function getActivePill(filterName) {
    var pill = fb.querySelector('[data-fb-filter="' + filterName + '"] .fb__chart-pill.is-active');
    return pill ? pill.getAttribute('data-value') : null;
  }

  /* ── Chart pill click handlers ── */
  var chartPills = fb.querySelectorAll('.fb__chart-pill');
  for (var i = 0; i < chartPills.length; i++) {
    chartPills[i].addEventListener('click', function() {
      var siblings = this.parentElement.querySelectorAll('.fb__chart-pill');
      for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-active');
      this.classList.add('is-active');

      var filterGroup = this.parentElement.getAttribute('data-fb-filter');
      if (filterGroup === 'pant-type') {
        renderPantsTable('fb-pants-table', this.getAttribute('data-value'));
      } else if (filterGroup === 'shirt-fit' || filterGroup === 'shirt-sizing') {
        renderShirtsTable('fb-shirts-table', getActivePill('shirt-fit'), getActivePill('shirt-sizing'));
      } else if (filterGroup === 'jacket-fit' || filterGroup === 'jacket-length') {
        renderJacketsTable('fb-jackets-table', getActivePill('jacket-fit'), getActivePill('jacket-length'));
      } else if (filterGroup === 'suit-jacket-fit' || filterGroup === 'suit-jacket-length') {
        renderJacketsTable('fb-suit-jackets-table', getActivePill('suit-jacket-fit'), getActivePill('suit-jacket-length'));
      } else if (filterGroup === 'suit-pant-type') {
        renderPantsTable('fb-suit-pants-table', this.getAttribute('data-value'));
      }
    });
  }

  /* ── Initialize size charts ── */
  renderPantsTable('fb-pants-table', 'dress_pant');
  renderShirtsTable('fb-shirts-table', 'slim_fit', 'collar');
  renderJacketsTable('fb-jackets-table', 'slim', 'regular');
  renderJacketsTable('fb-suit-jackets-table', 'slim', 'regular');
  renderPantsTable('fb-suit-pants-table', 'dress_pant');
})();
